import { useContext } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import MyDataSpacesViewContext from '../../context/MyDataSpacesViewContext';

const BackButton = () => {
	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);

	const returnToDataDirectory = () => {
		myDataSpacesViewContext.changeViewHandler('editDataSpaceFormConfigureDataSpace');
	};

	return (
		<Button variant="contained" margin="normal" color="primary" onClick={returnToDataDirectory}>
			Back
		</Button>
	);
};

export default BackButton;
